<template>
  <div class="second">
    <p
      class="mode"
      :style="{
        color: '#2187FF',
        'border-bottom': '#2187FF 1px solid',
      }"
      v-if="$route.query.type == 1 || !$route.query.type"
    >
      <span
        :style="{
          'border-left': '#2187FF 6px solid',
        }"
        >交易项目</span
      >
    </p>
    <div class="back" v-else>
      <!-- <el-button v-if="showBack" type="primary" icon="el-icon-back" @click="back" class="button" size="mini" style="width: 73px;height:40px;text-align:center;line-height:28px">返回</el-button> -->
      <button v-if="showBack" @click="back">
        <i class="el-icon-back"></i> 返回
      </button>
      <span v-else style="opacity: 0"></span>
      <h1
        style="font-family: kaiti; font-weight: blod; font-size: 46px"
        :style="{
          color: '#2187FF',
        }"
      >
        {{
          $route.query.areaName
            ? $route.query.areaName + "农村集体产权交易平台"
            : this.cityDetail.cityName + "农村集体产权交易平台"
        }}
      </h1>
      <span v-if="showBack" style="opacity: 0"></span>
      <span v-else style="opacity: 0"></span>
    </div>
    <div class="typeList">
      <div style="display: flex">
        <div
          @click="updeatType(index)"
          v-for="(data, index) in typeList"
          :key="index"
          class="typeDev"
          :class="{ typeDevAct: typeIndex == index }"
          :style="{
            'background-color': typeIndex == index ? '#2187FF' : '#fff',
          }"
        >
          <span
            class="typeSpan"
            :class="{ typeSpanAct: typeIndex == index }"
            :style="{
              color: typeIndex != index ? '#2187FF' : '#fff',
            }"
          >
            {{ data.label }}</span
          >
        </div>
      </div>
      <router-link
        style="
          height: 80px;
          line-height: 80px;
          font-size: 25px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          margin-right: 30px;
        "
        :style="{
          color: '#2187FF',
        }"
        :to="{
          name: '交易项目',
          query: {
            dm: reqPayload.deptId,
            index: typeIndex,
            idx: this.idx,
            statusIndex: statusIndex + 1,
          },
        }"
        >更多></router-link
      >
    </div>
    <ul class="second_ul">
      <li
        :style="{
          'background-color': '#2187FF',
          width: cityDetail.cityName == '许昌市' ? '127px' : '184px',
        }"
        :class="{ actTable: index == idx }"
        v-for="(item, index) in typeList[typeIndex].li_bg"
        :key="index"
        @click="changeTable(item.code, index)"
      >
        <!-- <img :src="item.mainImg" alt /> -->
        <img :src="item.activeImg" alt="加载失败" />
        <span
          :style="{
            'max-width': cityDetail.cityName == '许昌市' ? '130px' : '180px',
            width: cityDetail.cityName == '许昌市' ? '130px' : '180px',
          }"
          style="white-space: wrap; text-align: center"
          >{{ item.name }}</span
        >
      </li>
    </ul>
    <div
      style="
        display: flex;
        align-items: center;
        padding: 0 10px;
        font-size: 20px;
        font-size: 20px;
        margin: 0px 0px 10px;
      "
    >
      <span>选择区域</span>
      <div class="select" @click="showDeptList = !showDeptList">
        <span>{{ getDeptName(reqPayload.deptId) }}</span>
        <div :style="showDeptList ? {} : { display: 'none' }">
          <span
            @click="checkCity(city.deptId)"
            class="native"
            v-for="(city, index) in cityList"
            :key="index"
            >{{ city.deptName }}</span
          >
        </div>
      </div>
      <span v-if="typeIndex != 2">选择面积</span>
      <div
        v-if="typeIndex != 2"
        class="select"
        @click="showAreaList = !showAreaList"
      >
        <span>{{ getAreaName(area) }}</span>
        <div :style="showAreaList ? {} : { display: 'none' }">
          <span
            class="native"
            @click="checkArea(index)"
            v-for="(area1, index) in areaList"
            :key="index"
            >{{ area1.label }}</span
          >
        </div>
      </div>
      <span>关键字</span>
      <el-input
        style="width: 250px; padding: 0 10px"
        placeholder="请输入关键字"
        v-model="reqPayload.keyword"
      ></el-input>
      <el-button
        type="primary"
        size="medium"
        @click="updeatType(typeIndex, idx)"
        >搜索</el-button
      >
    </div>
    <div>
      <XiangMuHuiXian
        :jjz="jjz"
        @selectStatus="selectStatus"
        :type="typeList[typeIndex].type"
        :xiangmuList="xiangmuList"
        v-if="xiangmuList.length && cityDetail.cityName == '辉县市'"
        :status="typeIndex"
      />
      <XiangMuHuoJia
        :jjz="jjz"
        @selectStatus="selectStatus"
        :type="typeList[typeIndex].type"
        :xiangmuList="xiangmuList"
        v-else-if="xiangmuList.length && cityDetail.cityName == '获嘉县'"
        :status="typeIndex"
      />
      <XiangMu
        :jjz="jjz"
        @selectStatus="selectStatus"
        :type="typeList[typeIndex].type"
        :xiangmuList="xiangmuList"
        v-else-if="xiangmuList.length"
        :status="typeIndex"
      ></XiangMu>
      <div v-else class="zanwu">暂无数据...</div>
      <div
        style="display: flex; align-items: center; justify-content: end"
        v-if="xiangmuList.length"
      >
        <el-pagination
          layout="prev, pager, next, total"
          :total="xiangmuTotal"
          @prev-click="prevClick"
          @next-click="nextClick"
          :page-size="7"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import XiangMu from './XiangMu2.vue'
import XiangMuHuiXian from './XiangMu2_辉县版本.vue'
import XiangMuHuoJia from './XiangMu2_获嘉版本.vue'
import { getProList, outProjectList } from '../../api/交易项目'
import { getInvitationList } from '../../api/招投标'
import { getNeedProjectList } from '../../api/产权需求'
import { cityDetail } from '../../util/mainOption'
import { getTownList } from '../../api/Head'
export default {
  components: {
    XiangMu,
    XiangMuHuiXian,
    XiangMuHuoJia,
  },
  data () {
    return {
      imgList: [],

      jjz: true,
      // 小分类下标
      idx: 0,
      xiangmuList: [
        [
          {
            status: '公示中',
            statusImg: require('@/assets/img/公示中.png'),
          },
          {
            status: '报名中',
            statusImg: require('@/assets/img/报名中.png'),
          },
          {
            status: '竞价中',
            statusImg: require('@/assets/img/竞价中.png'),
          },
          {
            status: '已成交',
            statusImg: require('@/assets/img/已成交.png'),
          },
        ],
      ],
      showDeptList: false,
      showAreaList: false,
      cityList: [],
      area: '0',
      areaList: [
        {
          label: '全部',
        },
        {
          label: '0 ~ 10亩',
        },
        {
          label: '10 ~ 100亩',
        },
        {
          label: '100 ~ 200亩',
        },
        {
          label: '200 ~ 500亩',
        },
        {
          label: '500亩以上',
        },
      ],
      areaList1: [
        {
          areaBegin: '',
          areaEnd: '',
        },
        {
          areaBegin: '0',
          areaEnd: '10',
        },
        {
          areaBegin: '10',
          areaEnd: '100',
        },
        {
          areaBegin: '100',
          areaEnd: '200',
        },
        {
          areaBegin: '200',
          areaEnd: '500',
        },
        {
          areaBegin: '500',
          areaEnd: '',
        },
      ],
      number: '001',
      xiangmuTotal: 0,
      // 请求项目列表负载
      reqPayload: {
        pageNum: 1,
        pageSize: 7,
        number: '',
        deptId: '',
        pid: '',
        statusStr: (cityDetail.projectAllStatus || '2,3,4,5,6,7,8,9,10,11'),
        keyword: '',
        searchValue: '',
        // status: "2"
      },
      // 大类型下标
      typeIndex: 0,
      statusList: [],
      statusIndex: -1,
      backUrl: '',
      showBack: false,
    }
  },
  created () {
    getTownList().then((res) => {
      console.log("getTownList", res)
      this.cityList = [
        {
          deptName: this.cityDetail.cityName,
          deptId: this.cityDetail.deptId,
        },
        ...res.data.data,
      ]
    })
    // console.log(this.$route.query);
    this.reqPayload.deptId = localStorage.getItem('deptId')

    this.updeatType(this.typeIndex)
    window.addEventListener('click', (e) => {
      if (!(e.target.className == 'native' || e.target.className == 'select')) {
        this.showDeptList = false
        this.showAreaList = false
      }
    })
  },
  mounted () {
    if (
      location.search.indexOf('backUrl=') >= 0 ||
      location.hash.indexOf('backUrl=') >= 0
    ) {
      this.showBack = true
      this.backUrl =
        location.search.indexOf('backUrl=') >= 0
          ? decodeURIComponent(
            location.search.split('backUrl=')[1].split('&')[0]
          )
          : decodeURIComponent(location.hash.split('backUrl=')[1].split('&')[0])
    }
  },
  computed: {},
  watch: {},
  methods: {
    setProjectStatusList (type) {
      if (type == "1") {
        this.statusList = cityDetail.invitationStatusList ? cityDetail.invitationStatusList : [
          {
            status: '公示中',
            statusStr: '2',
            statusImg: require('@/assets/img/公示中.png'),
            statusImg1: require('@/assets/img/公示中1.png'),
          },
          {
            status: '报名中',
            statusImg: require('@/assets/img/报名中.png'),
            statusImg1: require('@/assets/img/报名中1.png'),
            statusStr: '4',
          },
          {
            status: '竞价中',
            statusImg: require('@/assets/img/竞价中.png'),
            statusImg1: require('@/assets/img/竞价中1.png'),
            statusStr: '6',
          },
          {
            status: '已结束',
            statusImg: require('@/assets/img/已成交.png'),
            statusImg1: require('@/assets/img/已成交1.png'),
            statusStr: '5,10',
          },
        ]
      } else if (type == "2") {
        this.statusList = cityDetail.outStatusList ? cityDetail.outStatusList : [
          {
            status: '公示中',
            statusStr: '2',
            statusImg: require('@/assets/img/公示中.png'),
            statusImg1: require('@/assets/img/公示中1.png'),
          },
          {
            status: '报名中',
            statusImg: require('@/assets/img/报名中.png'),
            statusImg1: require('@/assets/img/报名中1.png'),
            statusStr: '4',
          },
          {
            status: '竞价中',
            statusImg: require('@/assets/img/竞价中.png'),
            statusImg1: require('@/assets/img/竞价中1.png'),
            statusStr: '6',
          },
          {
            status: '已成交',
            statusImg: require('@/assets/img/已成交.png'),
            statusImg1: require('@/assets/img/已成交1.png'),
            statusStr: '7,8,9',
          },
        ]
      } else if (type == "3") {
        this.statusList = cityDetail.needStatusList ? cityDetail.needStatusList : [
          {
            status: '公示中',
            statusStr: '2',
            statusImg: require('@/assets/img/公示中.png'),
            statusImg1: require('@/assets/img/公示中1.png'),
          },
          {
            status: '报名中',
            statusImg: require('@/assets/img/报名中.png'),
            statusImg1: require('@/assets/img/报名中1.png'),
            statusStr: '4',
          },
          {
            status: '竞价中',
            statusImg: require('@/assets/img/竞价中.png'),
            statusImg1: require('@/assets/img/竞价中1.png'),
            statusStr: '6',
          },
          {
            status: '已成交',
            statusImg: require('@/assets/img/已成交.png'),
            statusImg1: require('@/assets/img/已成交1.png'),
            statusStr: '7,8,9',
          },
        ]
      }
    },
    checkCity (deptId) {
      this.reqPayload.deptId = deptId
    },
    checkArea (index) {
      this.area = index
    },
    getDeptName (val) {
      for (let i = 0; i < this.cityList.length; i++) {
        if (this.cityList[i].deptId == val) {
          return this.cityList[i].deptName
        }
      }
    },
    getAreaName (val) {
      for (let i = 0; i < this.areaList.length; i++) {
        if (i == val) {
          return this.areaList[i].label
        }
      }
    },
    back () {
      window.open(this.backUrl)
    },
    selectStatus (statusStr, statusIndex) {
      if (statusIndex == -1) {
        this.statusIndex = -1
        this.reqPayload.statusStr = (cityDetail.projectAllStatus || '2,3,4,5,6,7,8,9,10,11')
      } else {
        this.statusIndex = statusIndex
        this.reqPayload.statusStr = statusStr
      }
      console.log(this.statusIndex)
      this.requestList()
    },
    changeTable (i, idx) {
      this.idx = idx
      this.reqPayload.pageNum = 1
      this.reqPayload.number = i
      console.log(this.reqPayload)
      this.requestList()
    },
    requestList () {
      // if (this.reqPayload.number == "") {
      //   this.xiangmuList = []
      //   this.xiangmuTotal = 0
      //   return
      // }
      let area = {}
      if (this.areaList1[this.area].areaBegin != '') {
        area.areaBegin = this.areaList1[this.area].areaBegin
      }
      if (this.areaList1[this.area].areaEnd != '') {
        area.areaEnd = this.areaList1[this.area].areaEnd
      }
      if (this.typeIndex == 2) {
        let inType = this.typeList[this.typeIndex].type
        this.typeList[this.typeIndex].type = this.reqPayload.number
        this.reqPayload.pid = this.reqPayload.deptId
        this.reqPayload.searchValue = this.reqPayload.keyword
        getInvitationList({
          type: this.typeList[this.typeIndex].type,
          ...this.reqPayload,
        }).then((res) => {
          this.xiangmuList = [this.statusList, ...res.data.rows]
          console.log("this.statusList1", this.statusList)
          this.xiangmuTotal = res.data.total
          this.typeList[this.typeIndex].type = inType
        })
      } else if (this.typeIndex == 0) {
        outProjectList({
          ...this.reqPayload,
          type: this.typeList[this.typeIndex].type,
          ...area,
        }).then((res) => {
          this.xiangmuList = [this.statusList, ...res.data.rows]
          this.xiangmuTotal = res.data.total
        })
      } else if (this.typeIndex == 1) {
        let form = new FormData()
        form.append('type', this.typeList[this.typeIndex].type)
        form.append('pageNum', this.reqPayload.pageNum)
        form.append('pageSize', this.reqPayload.pageSize)
        form.append(
          'number',
          this.typeList[this.typeIndex].li_bg[this.idx]
            ? this.typeList[this.typeIndex].li_bg[this.idx].code
            : ''
        )
        form.append('statusStr', this.reqPayload.statusStr)
        if (this.areaList1[this.area].areaBegin != '') {
          form.append('params[areaBegin]', this.areaList1[this.area].areaBegin)
        }
        if (this.areaList1[this.area].areaEnd != '') {
          form.append('params[areaEnd]', this.areaList1[this.area].areaEnd)
        }
        form.append('keyword', this.reqPayload.keyword)
        form.append('searchValue', this.reqPayload.keyword)
        form.append('deptId', this.reqPayload.deptId)
        form.append('pid', this.reqPayload.deptId)
        console.log("form", form)
        getNeedProjectList(form).then((res) => {
          this.xiangmuList = [this.statusList, ...res.data.rows]
          this.xiangmuTotal = res.data.total
        })
      } else {
        this.xiangmuList = []
        this.xiangmuTotal = 0
      }
    },
    updeatType (i) {
      this.typeIndex = i
      this.reqPayload.pageNum = 1
      this.setProjectStatusList(this.typeList[this.typeIndex].type)
      if (i == 2) {
        this.jjz = false
      } else {
        this.jjz = true
      }
      this.idx = 0
      if (!!this.typeList[this.typeIndex].li_bg.length) {
        this.reqPayload.number = this.typeList[this.typeIndex].li_bg[this.idx]
          ? this.typeList[this.typeIndex].li_bg[this.idx].code
          : ''
        this.requestList()
        return
      }
      getProList({ type: this.typeList[this.typeIndex].type }).then((res) => {
        this.typeList[this.typeIndex].li_bg = res.data.data
        this.typeList[this.typeIndex].li_bg.unshift(this.mainType)
        this.reqPayload.number = res.data.data[this.idx]
          ? res.data.data[this.idx].code
          : ''
        this.requestList()
      })
    },
    prevClick () {
      this.reqPayload.pageNum--
      this.requestList()
    },
    nextClick () {
      this.reqPayload.pageNum++
      this.requestList()
    },
    currentChange (e) {
      this.reqPayload.pageNum = e
      this.requestList()
    },
    // 跳转到交易项目
    tojiaoyi (i) {
      this.idx = i
      this.$router.push({
        name: '交易项目',
        query: { index: this.typeIndex, idx: this.idx },
      })
      // , code: code
    },
    // 跳转到交易项目详情
    toxiangmu2 (data) {
      // console.log(data);
      if (data.number && data.number == '009') {
        this.$router.push({
          path: '/tradingProject/pressCenterDetail1',
          query: { id: data.id, keys: data.keys, number: this.number },
        })
      } else {
        this.$router.push({
          path: '/tradingProject/pressCenterDetail',
          query: { id: data.id, keys: data.keys, number: this.number },
        })
      }
    },
  },
}
</script>

<style scoped>
.typeList {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.typeDev {
  text-align: center;
  height: 60px;
  border: 1px solid #ddd;
  width: 300px;
  line-height: 60px;
  cursor: pointer;
  background-color: #fff;
}

.typeDevAct {
  text-align: center;
  height: 60px;
  border: 1px solid #ddd;
  width: 300px;
  line-height: 60px;
  cursor: pointer;
}

.typeSpan {
  font-size: 24px;
  font-weight: 600;
}

.typeSpanAct {
  color: #fff;
  font-size: 24px;
  font-weight: 600;
}

.mode {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 61px 0 37px;
  /* width: 1174px; */
  height: 80px;
}

.mode > span {
  display: block;
  width: auto;
  height: 50px;
  font-size: 37px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  padding-left: 5px;
  line-height: 50px;
}

/deep/ .el-pagination {
  height: 30px;
}

ul {
  margin: 0;
  padding: 0;
}

.zanwu {
  color: #666;
  font-size: 28px;
  padding-left: 30px;
}

.second {
  display: flex;
  flex-direction: column;
  /* margin: 35px auto; */
  margin-bottom: 15px;
  width: 100%;
  min-height: 650px;
  background: #ffffff;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
  overflow: hidden;
}
.second_ul {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 100%;
  height: 158px;
}

.second_ul > li {
  display: block;
  height: 104px;
  border-radius: 10px;
  background-color: #6681ea;
  box-shadow: 0px 0px 24px 0px rgba(21, 21, 21, 0.1);
  cursor: pointer;
  margin-left: 26px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.second_ul > li:first-child {
  margin-left: 0px;
}

.second_ul > li > img {
  display: block;
  /* width: 136px; */
  /* height: 100%; */
  width: 50px;
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.second_ul > li > span {
  white-space: nowrap;
  color: #fff;
  position: absolute;
  top: 74%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
}

.second_table {
  width: 100%;
}

.second_table tr {
  cursor: pointer;
}

.first_tr {
  width: 100%;
  height: 50px;
  background-color: #2187ff;
}

.first_tr th {
  height: 50px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
}

td {
  max-width: 311px;
  height: 51px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 51px;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.red {
  color: #f55252;
}

.green {
  color: #0f0;
}

.actTable {
  box-shadow: 10px 10px 5px 0px #666 !important;
}
.back {
  padding: 20px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back > span {
  font-size: 30px;
  padding: 12px 28px;
  background-color: #2187ff;
  text-align: center;
  border-radius: 6px;
  color: #fff;
  cursor: pointer;
}
.back > button {
  line-height: 34px;
  height: 34px;
  width: 80px;
  color: #fff;
  border: 1px solid #2187ff;
  background-color: #2187ff;
  cursor: pointer;
  opacity: 1;
  border-radius: 2px;
}
.select {
  border: 2px solid #ddd;
  position: relative;
  width: 250px;
  height: 40px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  padding: 0px 8px;
  font-size: 16px;
  cursor: pointer;
}
.select > div {
  position: absolute;
  top: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  font-size: 16px;
  width: 100%;
  z-index: 99;
  box-sizing: border-box;
  border: 1px solid #ddd;
  border-radius: 6px;
  max-height: 260px;
  overflow: auto;
}
.select > div > span {
  padding: 8px;
}
.select > div > span:hover {
  background-color: #ddd;
  cursor: pointer;
}
</style>
